import { Language } from '../context/LanguageContext';

export interface WatchTranslation {
    header: {
        title: string;
        mainTitle: string;
    };
    firstSection: {
        title: string;
        description: string;
    };
    models: {
        singular: string;
        plural: string;
    };
    variations: string;
    specs: {
        mechanicalMovement: string;
        quartzMovement: string;
        diameter: string;
        depth: string;
        waterproofness: string;
        watchGlass: string;
        material: string;
        thickness: string;
    };
}

interface WatchPageTranslations {
    [key: string]: Partial<Record<Language, WatchTranslation>>;
}

export const watchPageTranslations: WatchPageTranslations = {
    lucidity: {
        'en': {
            header: {
                title: 'LUCIDITY',
                mainTitle: 'THE BEAUTY OF THE ESSENTIAL',
            },
            firstSection: {
                title: 'Lucidity',
                description: 'The joy to simply be. To live - not to be lived. Strength in the simplicity, strength in the focus, the power to be what we are.',
            },
            models: {
                singular: 'MODEL',
                plural: 'VARIATIONS',
            },
            variations: 'Variations of Lucidity',
            specs: {
                mechanicalMovement: 'MECHANICAL MOVEMENT',
                quartzMovement: 'QUARTZ MOVEMENT',
                diameter: 'diameter',
                depth: 'depth',
                waterproofness: 'WATERPROOFNESS',
                watchGlass: 'WATCH GLASS',
                material: 'MATERIAL',
                thickness: 'Thickness',
            },
        },
        'de': {
            header: {
                title: 'LUCIDITY',
                mainTitle: 'DER AUSDRUCK DES WESENTLICHEN',
            },
            firstSection: {
                title: 'Lucidity',
                description: 'Die Freude, einfach zu sein. Zu leben - nicht gelebt zu werden. Die Kraft der Einfachheit, die Bedeutung des Fokussierens, die Macht zu sein, was wir sind.',
            },
            models: {
                singular: 'MODELL',
                plural: 'VARIATIONEN',
            },
            variations: 'Variationen der Lucidity',
            specs: {
                mechanicalMovement: 'MECHANISCHES WERK',
                quartzMovement: 'QUARZWERK',
                diameter: 'Durchmesser',
                depth: 'Tiefe',
                waterproofness: 'Wasserdichte',
                watchGlass: 'UHRGLAS',
                material: 'MATERIAL',
                thickness: 'Höhe',
            },
        },
        'zh': {
            header: {
                title: '清晰',
                mainTitle: '本質之美',
            },
            firstSection: {
                title: '清晰',
                description: '簡樸存在的喜悅。生活-而非被生活。力量就在簡樸之中，力量就在專注之中，成就我們本質的力量。',
            },
            models: {
                singular: '款式',
                plural: '變體',
            },
            variations: 'Lucidity的變體',
            specs: {
                mechanicalMovement: '機械機芯',
                quartzMovement: '石英機芯',
                diameter: '直徑',
                depth: '深度',
                waterproofness: '防水性',
                watchGlass: '錶鏡',
                material: '材質',
                thickness: '厚度',
            },
        },
        'fr': {
            header: {
                title: 'LUCIDITY',
                mainTitle: 'LA BEAUTÉ DE L\'ESSENTIEL',
            },
            firstSection: {
                title: 'Lucidity',
                description: 'La joie d\'être, tout simplement. Vivre - ne pas être vécu. La force de la simplicité, la force de la concentration, le pouvoir d\'être ce que nous sommes.',
            },
            models: {
                singular: 'MODÈLE',
                plural: 'VARIATIONS',
            },
            variations: 'Variations de Lucidity',
            specs: {
                mechanicalMovement: 'MOUVEMENT MÉCANIQUE',
                quartzMovement: 'MOUVEMENT À QUARTZ',
                diameter: 'diamètre',
                depth: 'profondeur',
                waterproofness: 'ÉTANCHÉITÉ',
                watchGlass: 'VERRE DE MONTRE',
                material: 'MATÉRIAUX',
                thickness: 'Épaisseur',
            },
        },
    },
    introsistence: {
        'en': {
            header: {
                title: 'INTROSISTENCE',
                mainTitle: 'THE INNER DEPTH',
            },
            firstSection: {
                title: 'Introsistence',
                description: 'The circle, symbol of the totality. Strength from within. The one who lives within is not hit by the storm outside. Detachment is the master of independence.',
            },
            models: {
                singular: 'MODEL',
                plural: 'VARIATIONS',
            },
            variations: 'Variations of Introsistence',
            specs: {
                mechanicalMovement: 'MECHANICAL MOVEMENT',
                quartzMovement: 'QUARTZ MOVEMENT',
                diameter: 'diameter',
                depth: 'depth',
                waterproofness: 'WATERPROOFNESS',
                watchGlass: 'WATCH GLASS',
                material: 'MATERIAL',
                thickness: 'Thickness',
            },
        },
        'de': {
            header: {
                title: 'INTROSISTENCE',
                mainTitle: 'DIE INNERE TIEFE',
            },
            firstSection: {
                title: 'Introsistence',
                description: 'Der Kreis, Symbol für die Gesamtheit. Die Kraft von innen. Wer im Inneren lebt, wird von den Stürmen des Äußeren nicht berührt. Die Losgelöstheit ist der Meister der Unabhängigkeit.',
            },
            models: {
                singular: 'MODELL',
                plural: 'VARIATIONEN',
            },
            variations: 'Variationen der Introsistence',
            specs: {
                mechanicalMovement: 'MECHANISCHES WERK',
                quartzMovement: 'QUARZWERK',
                diameter: 'Durchmesser',
                depth: 'Tiefe',
                waterproofness: 'Wasserdichte',
                watchGlass: 'UHRGLAS',
                material: 'MATERIAL',
                thickness: 'Höhe',
            },
        },
        'zh': {
            header: {
                title: '內在堅持',
                mainTitle: '內在深度',
            },
            firstSection: {
                title: '內在堅持',
                description: '圓，象徵著整體。內在的力量。生活在內心的人不會被外面的風暴擊中。超然是獨立的主宰。',
            },
            models: {
                singular: '款式',
                plural: '變體',
            },
            variations: 'Introsistence的變體',
            specs: {
                mechanicalMovement: '機械機芯',
                quartzMovement: '石英機芯',
                diameter: '直徑',
                depth: '深度',
                waterproofness: '防水性',
                watchGlass: '錶鏡',
                material: '材質',
                thickness: '厚度',
            },
        },
        'fr': {
            header: {
                title: 'INTROSISTENCE',
                mainTitle: 'LA PROFONDEUR INTÉRIEURE',
            },
            firstSection: {
                title: 'Introsistence',
                description: 'Le cercle, symbole de la totalité. La force de l\'intérieur. Celui qui vit à l\'intérieur n\'est pas frappé par la tempête à l\'extérieur. Le détachement est le maître de l\'indépendance.',
            },
            models: {
                singular: 'MODÈLE',
                plural: 'VARIATIONS',
            },
            variations: 'Variations d\'Introsistence',
            specs: {
                mechanicalMovement: 'MOUVEMENT MÉCANIQUE',
                quartzMovement: 'MOUVEMENT À QUARTZ',
                diameter: 'diamètre',
                depth: 'profondeur',
                waterproofness: 'ÉTANCHÉITÉ',
                watchGlass: 'VERRE DE LA MONTRE',
                material: 'MATÉRIAUX',
                thickness: 'Épaisseur',
            },
        },
    },
    determination: {
        'en': {
            header: {
                title: 'DETERMINATION',
                mainTitle: 'THE POWER TO KNOW ONE\'S AIMS',
            },
            firstSection: {
                title: 'Determination',
                description: 'The capacity to define one\'s target and not to want anything else. Victory by concentrating all force on the essential.',
            },
            models: {
                singular: 'MODEL',
                plural: 'VARIATIONS',
            },
            variations: 'Variations of Determination',
            specs: {
                mechanicalMovement: 'MECHANICAL MOVEMENT',
                quartzMovement: 'QUARTZ MOVEMENT',
                diameter: 'diameter',
                depth: 'depth',
                waterproofness: 'WATERPROOFNESS',
                watchGlass: 'WATCH GLASS',
                material: 'MATERIAL',
                thickness: 'Thickness',
            },
        },
        'de': {
            header: {
                title: 'DETERMINATION',
                mainTitle: 'DIE KRAFT, SEINE ZIELE ZU KENNEN',
            },
            firstSection: {
                title: 'Determination',
                description: 'Die Fähigkeit, sein Ziel zu definieren und nichts Anderes zu wollen. Überlegenheit durch Konzentration aller Kräfte auf das Wesentliche.',
            },
            models: {
                singular: 'MODELL',
                plural: 'VARIATIONEN',
            },
            variations: 'Variationen der Determination',
            specs: {
                mechanicalMovement: 'MECHANISCHES WERK',
                quartzMovement: 'QUARZWERK',
                diameter: 'Durchmesser',
                depth: 'Tiefe',
                waterproofness: 'Wasserdichte',
                watchGlass: 'UHRGLAS',
                material: 'MATERIAL',
                thickness: 'Höhe',
            },
        },
        'zh': {
            header: {
                title: '決心',
                mainTitle: '了解自己目標的力量',
            },
            firstSection: {
                title: '決心',
                description: '定義自己目標並且不想要其他任何東西的能力。通過將所有力量集中在本質上而獲得勝利。',
            },
            models: {
                singular: '款式',
                plural: '變體',
            },
            variations: 'Determination的變體',
            specs: {
                mechanicalMovement: '機械機芯',
                quartzMovement: '石英機芯',
                diameter: '直徑',
                depth: '深度',
                waterproofness: '防水性',
                watchGlass: '錶鏡',
                material: '材質',
                thickness: '厚度',
            },
        },
        'fr': {
            header: {
                title: 'DETERMINATION',
                mainTitle: 'LE POUVOIR DE CONNAÎTRE SES OBJECTIFS',
            },
            firstSection: {
                title: 'Determination',
                description: 'La capacité à définir sa cible et à ne pas vouloir autre chose. La victoire en concentrant toutes les forces sur l\'essentiel.',
            },
            models: {
                singular: 'MODÈLE',
                plural: 'VARIATIONS',
            },
            variations: 'Variations de Determination',
            specs: {
                mechanicalMovement: 'MOUVEMENT MÉCANIQUE',
                quartzMovement: 'MOUVEMENT À QUARTZ',
                diameter: 'diamètre',
                depth: 'profondeur',
                waterproofness: 'ÉTANCHÉITÉ',
                watchGlass: 'VERRE DE LA MONTRE',
                material: 'MATÉRIAUX',
                thickness: 'Épaisseur',
            },
        },
    },
    connaissance: {
        'en': {
            header: {
                title: 'CONNAISSANCE',
                mainTitle: 'THE SELF-DISCOVERY',
            },
            firstSection: {
                title: 'Connaissance',
                description: 'Knowing yourself knows everything. To know oneself brings control of oneself. Control of oneself brings control of everything. The shadow of self-knowledge is self-realization.',
            },
            models: {
                singular: 'MODEL',
                plural: 'VARIATIONS',
            },
            variations: 'Variations of Connaissance',
            specs: {
                mechanicalMovement: 'MECHANICAL MOVEMENT',
                quartzMovement: 'QUARTZ MOVEMENT',
                diameter: 'diameter',
                depth: 'depth',
                waterproofness: 'WATERPROOFNESS',
                watchGlass: 'WATCH GLASS',
                material: 'MATERIAL',
                thickness: 'Thickness',
            },
        },
        'de': {
            header: {
                title: 'CONNAISSANCE',
                mainTitle: 'DIE ERKENNTNIS',
            },
            firstSection: {
                title: 'Connaissance',
                description: 'Wer sich selbst kennt, kennt alles. Sich selbst zu kennen, bringt Kontrolle über sich selbst. Die Kontrolle über sich selbst bringt die Kontrolle über alles. Die Selbstverwirklichung folgt der Selbsterkenntnis wie ihr Schatten.',
            },
            models: {
                singular: 'MODELL',
                plural: 'VARIATIONEN',
            },
            variations: 'Variationen von Connaissance',
            specs: {
                mechanicalMovement: 'MECHANISCHES WERK',
                quartzMovement: 'QUARZWERK',
                diameter: 'Durchmesser',
                depth: 'Tiefe',
                waterproofness: 'Wasserdichte',
                watchGlass: 'UHRGLAS',
                material: 'MATERIAL',
                thickness: 'Höhe',
            },
        },
        'zh': {
            header: {
                title: '認知',
                mainTitle: '自我發現',
            },
            firstSection: {
                title: '認知',
                description: '了解自己就是了解一切。了解自己帶來對自己的控制。對自己的控制帶來對一切的控制。自我認知的影子是自我實現。',
            },
            models: {
                singular: '款式',
                plural: '變體',
            },
            variations: 'Connaissance的變體',
            specs: {
                mechanicalMovement: '機械機芯',
                quartzMovement: '石英機芯',
                diameter: '直徑',
                depth: '深度',
                waterproofness: '防水性',
                watchGlass: '錶鏡',
                material: '材質',
                thickness: '厚度',
            },
        },
        'fr': {
            header: {
                title: 'CONNAISSANCE',
                mainTitle: 'LA DÉCOUVERTE DE SOI',
            },
            firstSection: {
                title: 'Connaissance',
                description: 'Se connaître, c\'est tout comprendre. La connaissance de soi apporte la maîtrise de soi. Se maîtriser, c\'est avoir le contrôle sur tout. L\'ombre de la connaissance de soi est la réalisation de soi.',
            },
            models: {
                singular: 'MODÈLE',
                plural: 'VARIATIONS',
            },
            variations: 'Variations de Connaissance',
            specs: {
                mechanicalMovement: 'MOUVEMENT MÉCANIQUE',
                quartzMovement: 'MOUVEMENT À QUARTZ',
                diameter: 'diamètre',
                depth: 'profondeur',
                waterproofness: 'ÉTANCHÉITÉ',
                watchGlass: 'VERRE DE MONTRE',
                material: 'MATÉRIAUX',
                thickness: 'Épaisseur',
            },
        },
    },
    essence_desthetique: {
        'en': {
            header: {
                title: 'ESSENCE D\'ESTHETIQUE',
                mainTitle: 'BEAUTY THAT NEEDS NO REASON AND NO PURPOSE',
            },
            firstSection: {
                title: 'Essence d\'esthetique',
                description: 'Unstained aesthetics is a power in itself. It does not have to labor or achieve. By its sheer existence, it has already fulfilled its purpose.',
            },
            models: {
                singular: 'MODEL',
                plural: 'VARIATIONS',
            },
            variations: 'Variations of Essence d\'Esthétique',
            specs: {
                mechanicalMovement: 'MECHANICAL MOVEMENT',
                quartzMovement: 'QUARTZ MOVEMENT',
                diameter: 'diameter',
                depth: 'depth',
                waterproofness: 'WATERPROOFNESS',
                watchGlass: 'WATCH GLASS',
                material: 'MATERIAL',
                thickness: 'Thickness',
            },
        },
        'de': {
            header: {
                title: 'ESSENCE D\'ESTHETIQUE',
                mainTitle: 'SCHÖNHEIT, DIE WEDER ANLASS NOCH ZWECK BENÖTIGT',
            },
            firstSection: {
                title: 'Essence d\'esthetique',
                description: 'Unverfälschte Ästhetik ist eine Kraft in sich selbst. Sie muss sich nicht anstrengen oder etwas leisten. Durch ihre bloße Existenz hat sie ihren Zweck bereits erfüllt.',
            },
            models: {
                singular: 'MODELL',
                plural: 'VARIATIONEN',
            },
            variations: 'Variationen von Essence d\'Esthétique',
            specs: {
                mechanicalMovement: 'MECHANISCHES WERK',
                quartzMovement: 'QUARZWERK',
                diameter: 'Durchmesser',
                depth: 'Tiefe',
                waterproofness: 'Wasserdichte',
                watchGlass: 'UHRGLAS',
                material: 'MATERIAL',
                thickness: 'Höhe',
            },
        },
        'zh': {
            header: {
                title: '美學本質',
                mainTitle: '不需理由和目的的美',
            },
            firstSection: {
                title: '美學本質',
                description: '純淨的美學本身就是一種力量。它不需要勞動或成就。僅憑其存在，它已經實現了其目的。',
            },
            models: {
                singular: '款式',
                plural: '變體',
            },
            variations: 'Essence d\'Esthétique的變體',
            specs: {
                mechanicalMovement: '機械機芯',
                quartzMovement: '石英機芯',
                diameter: '直徑',
                depth: '深度',
                waterproofness: '防水性',
                watchGlass: '錶鏡',
                material: '材質',
                thickness: '厚度',
            },
        },
        'fr': {
            header: {
                title: 'ESSENCE D\'ESTHETIQUE',
                mainTitle: 'UNE BEAUTÉ QUI N\'A BESOIN NI DE RAISON NI DE BUT',
            },
            firstSection: {
                title: 'Essence d\'esthetique',
                description: 'L\'esthétique immaculée est une puissance en soi. Elle n\'a pas besoin de travailler ni d\'accomplir quoi que ce soit. Par sa simple existence, elle a déjà rempli son but.',
            },
            models: {
                singular: 'MODÈLE',
                plural: 'VARIATIONS',
            },
            variations: 'Variations d\'Essence d\'Esthétique',
            specs: {
                mechanicalMovement: 'MOUVEMENT MÉCANIQUE',
                quartzMovement: 'MOUVEMENT À QUARTZ',
                diameter: 'diamètre',
                depth: 'profondeur',
                waterproofness: 'ÉTANCHÉITÉ',
                watchGlass: 'VERRE DE MONTRE',
                material: 'MATÉRIAUX',
                thickness: 'Épaisseur',
            },
        },
    },
    realization: {
        'en': {
            header: {
                title: 'REALIZATION',
                mainTitle: 'THE POWER OF IMPLEMENTATION',
            },
            firstSection: {
                title: 'Realization',
                description: 'The art to stay fully in the reality. The one who has mastered the concentration on the reality, who can keep all thoughts to what is real, can achieve anything.',
            },
            models: {
                singular: 'MODEL',
                plural: 'VARIATIONS',
            },
            variations: 'Variations of Realization',
            specs: {
                mechanicalMovement: 'MECHANICAL MOVEMENT',
                quartzMovement: 'QUARTZ MOVEMENT',
                diameter: 'diameter',
                depth: 'depth',
                waterproofness: 'WATERPROOFNESS',
                watchGlass: 'WATCH GLASS',
                material: 'MATERIAL',
                thickness: 'Thickness',
            },
        },
        'de': {
            header: {
                title: 'REALIZATION',
                mainTitle: 'DIE KRAFT DER VERWIRKLICHUNG',
            },
            firstSection: {
                title: 'Realization',
                description: 'Die Kunst, ganz in der Realität zu bleiben. Wer die Konzentration auf die Realität gemeistert hat, wer alle Gedanken auf die Realität richten kann, kann alles erreichen.',
            },
            models: {
                singular: 'MODELL',
                plural: 'VARIATIONEN',
            },
            variations: 'Variationen von Realization',
            specs: {
                mechanicalMovement: 'MECHANISCHES WERK',
                quartzMovement: 'QUARZWERK',
                diameter: 'Durchmesser',
                depth: 'Tiefe',
                waterproofness: 'Wasserdichte',
                watchGlass: 'UHRGLAS',
                material: 'MATERIAL',
                thickness: 'Höhe',
            },
        },
        'zh': {
            header: {
                title: '實現',
                mainTitle: '實施的力量',
            },
            firstSection: {
                title: '實現',
                description: '完全停留在現實中的藝術。掌握了對現實的專注，能夠將所有思想保持在真實的事物上的人，可以實現任何事情。',
            },
            models: {
                singular: '款式',
                plural: '變體',
            },
            variations: 'Realization的變體',
            specs: {
                mechanicalMovement: '機械機芯',
                quartzMovement: '石英機芯',
                diameter: '直徑',
                depth: '深度',
                waterproofness: '防水性',
                watchGlass: '錶鏡',
                material: '材質',
                thickness: '厚度',
            },
        },
        'fr': {
            header: {
                title: 'REALIZATION',
                mainTitle: 'LE POUVOIR DE LA MISE EN ŒUVRE',
            },
            firstSection: {
                title: 'Realization',
                description: 'L\'art de rester pleinement dans la réalité. Celui qui maîtrise la concentration sur la réalité, qui peut garder toutes ses pensées sur ce qui est réel, peut tout accomplir.',
            },
            models: {
                singular: 'MODÈLE',
                plural: 'VARIANTES',
            },
            variations: 'Variations de Realization',
            specs: {
                mechanicalMovement: 'MOUVEMENT MÉCANIQUE',
                quartzMovement: 'MOUVEMENT À QUARTZ',
                diameter: 'diamètre',
                depth: 'profondeur',
                waterproofness: 'ÉTANCHÉITÉ',
                watchGlass: 'VERRE DE MONTRE',
                material: 'MATÉRIAUX',
                thickness: 'Épaisseur',
            },
        },
    },
};

export function getWatchTranslations(productId: string, language: Language, defaultTranslation: WatchTranslation): WatchTranslation {
    return watchPageTranslations[productId]?.[language] || watchPageTranslations[productId]?.en || defaultTranslation;
} 